import { useEffect } from "react";

/**
 * useLenis — DISABLED 2026-08-15 (Founder plain-ink).
 *
 * The lenis smooth-scroll interpolator was introducing a nearly site-wide
 * micro-stutter — its rAF loop competes with the browser's compositor and
 * with framer-motion's animation frames, producing a "barely skipping"
 * timing artifact even when the underlying render quality is good.
 *
 * Native scroll on modern browsers is smooth enough on its own and hands
 * scroll animation off to the compositor thread instead of the main JS
 * thread. Kept as a no-op so per-page `useLenis()` calls remain valid.
 */
export default function useLenis() {
  useEffect(() => {}, []);
}
